const state = {
  isMobile: null,
}

const mutations = {
  setIsMobile(state, val) {
    state.isMobile = val;
  }
}

export default {
  namespaced: true, //成为带命名空间的模块。当模块被注册后，它的所有 getter、action 及 mutation 都会自动根据模块注册的路径调整命名
  state,
  mutations
}